import { useLocation, useNavigate } from "react-router-dom";
import "./OrderDone.css";
import React, { useEffect, useState } from "react";
import { kwaFormat, PlanDetails, plans } from "../../utils/UtilsFunc";
import { useApi } from "../../hooks/ApiProvider";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import { useAndroidBridge } from "../../hooks/useAndroidBridge";

const OrderDone = () => {
  const { approvePayment } = useApi();
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();

  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentResult, setPaymantResult] = useState<any | null>(null);
  const [mobileResult, setMobileResult] = useState<boolean | null>(null);

  // URL 쿼리 파라미터 파싱
  const queryParams = new URLSearchParams(location.search);
  const orderParams = {
    paymentType: queryParams.get("paymentType"),
    orderId: queryParams.get("orderId"),
    paymentKey: queryParams.get("paymentKey"),
    amount: queryParams.get("amount"),
  };

  const getReady = async () => {
    try {
      if (orderParams?.orderId !== null) {
        if (approvePayment) {
          let res = await approvePayment(orderParams);
          if (res?.success) {
            // 결제 성공
            setPaymantResult(res?.payment_data);

            isEmbed() && setMobileResult(true);

            navigate(``, { state: { ...res?.payment_data } });
          }
        }
      }
    } catch (error) {
      // 결제 실패ㄴ
      console.error(error);
    }

    // if (approvePayment) {
    //   approvePayment(orderParams)
    //     .then((response) => {
    //       console.log('Payment Approved:', response);
    //       if (response.success) {
    //         setPaymantResult(response?.payment_data);
    //
    //         // 결제 승인 성공 시 처리
    //         setIsLoading(false);
    //         // 추가적인 성공 처리 로직
    //         // navigate('./',{state:{...response?.payment_data}})
    //       } else {
    //         // 결제 승인 실패 시 처리
    //         setError(`결제 승인에 실패했습니다. [${response.message}]`);
    //         setIsLoading(false);
    //       }
    //     })
    //     .catch((error) => {
    //       console.error('결제 승인 중 오류 발생:', error);
    //       setError('결제 승인 중 오류가 발생했습니다.');
    //       setIsLoading(false);
    //     });
    // } else {
    //   setError('결제 승인 함수가 정의되어 있지 않습니다.');
    //   setIsLoading(false);
    // }
  };

  useEffect(() => {
    // console.warn('Order Parameters:', orderParams);
    getReady();
  }, []);

  // console.log(location?.state)

  // 모바일 전용 함수 : 모바일로 '확인'버튼. 클릭시 앱으로 이동
  const mobileBackToHome = () => {
    sendToAndroid("go-to-page", "");
  };

  return (
    <>
      <div className={`content_wrap order_done`}>
        <div className={`section_wrap sec_wrap_1`}>
          <div className={`sec sec_1`}>
            <div className={`result_message`}>
              <img
                src={`../contents/join_end.png`}
                alt={``}
                className={`m-auto`}
              />
              <h3 className={`h3`}>결제가 완료되었어요</h3>
            </div>
          </div>
          <div className={`sec sec_2`}>
            <div className={`order_done_result`}>
              <div className={`proc_info`}>
                <ul className={`price_ul`}>
                  <li>
                    <div className={`tit body1`}>상품명</div>
                    <div className={`txt body1_sb`}>
                      {location?.state?.order_name || "스토리북 구독"}
                    </div>
                  </li>
                  <li>
                    <div className={`tit body1`}>정가</div>
                    <div className={`txt body1_sb`}>
                      {kwaFormat(location?.state?.list_price) || "0"}원
                    </div>
                  </li>
                  <li>
                    <div className={`tit body1`}>할인 금액</div>
                    <div className={`txt body1_sb accent`}>
                      -{kwaFormat(location?.state?.discount_amount) || "0"}원
                    </div>
                  </li>
                </ul>
                <div
                  className={`total_price flex items-center justify-between`}
                >
                  <div className={`h3`}>최종 결제 금액</div>
                  <div className={`h3 success`}>
                    {kwaFormat(location?.state?.amount) || "0"}원
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 앱 전용 버튼 */}
        {isEmbed() && (
          <button className={`homeButton`} onClick={mobileBackToHome}>
            <span className={`homeButtonText`}>확인</span>
          </button>
        )}

        {/**-----------------------------선물하기로 결제시 화면노출-------------------------**/}
        {location?.state?.is_gift && (
          <div className={`section_wrap sec_wrap_2`}>
            <div className={`sec sec_1`}>
              <h3 className={`h3 tit text-center`}>
                받으시는 분의 전화번호로
                <br />
                선물 등록 방법을 보내드렸어요
              </h3>
              <div
                className={`coupon_guide flex flex-wrap justify-center text-center`}
              >
                {/**------------------------------------------------반복구간--------------------------------**/}
                <div className={`box`}>
                  <span className={`step`}>STEP 1</span>
                  <h3 className={`h3`}>웹에서 회원가입</h3>
                  <p className={`body1`}>
                    기억의 서랍 홈페이지에접속해서 회원가입 해주세요
                  </p>
                </div>
                <div className={`box`}>
                  <span className={`step`}>STEP 2</span>
                  <h3 className={`h3`}>웹에서 쿠폰 등록</h3>
                  <p className={`body1`}>
                    마이페이지에서 쿠폰코드를 입력해 주세요. (90일 이내에 등록)
                  </p>
                </div>
                <div className={`box`}>
                  <span className={`step`}>STEP 3</span>
                  <h3 className={`h3`}>앱 설치 & 인터뷰</h3>
                  <p className={`body1`}>
                    앱을 다운로드하고 인터뷰를 시작하세요
                  </p>
                </div>
              </div>
              <div className={`btn_group text-center`}>
                <button className={`btn btn-outline-primary`} onClick={()=>navigate(`/guide`)}>
                  스토리북 제작 과정 자세히 보기
                </button>
              </div>
            </div>
          </div>
        )}
        {/**-----------------------------일반결제시 화면 노출-------------------------**/}
        {!location?.state?.is_gift && !isEmbed() && (
          <div className={`section_wrap sec_wrap_2`}>
            <div className={`sec sec_2 text-center`}>
              <h3 className={`h3 tit text-center`}>
                인터뷰, 스토리북 제작 등 이후 모든 과정은 앱에서 할 수 있어요!
                <br />앱 다운로드 후 인터뷰를 시작해 보세요
              </h3>
              <div className={`app_download_group`}>
                <div className={`btn_group flex justify-center gap-[52px]`}>
                  <div>
                    <button className={`img_btn app_store`}></button>
                    <img
                      src={`../contents/QR_app_store.png`}
                      alt={`앱스토어 qr`}
                      className={`m-auto`}
                    />
                    <h3>휴대폰 카메라로 스캔</h3>
                  </div>
                  <div>
                    <button className={`img_btn play_store`}></button>
                    <img
                      src={`../contents/QR_play_store.png`}
                      alt={`플레이스토어 qr`}
                      className={`m-auto`}
                    />
                    <h3>휴대폰 카메라로 스캔</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default OrderDone;
